import "../../../../styles/workspace_styles/SystemAdministratorStyles/TenantAdministrators/DeleteTenantAdministrator.css";
import { useContext, useEffect, useState } from "react";
import { AppContext } from "../../../AppProvider";
import { TenantAdministratorContext } from "./TenantAdministratorProvider";
import { usersMicroserviceUrl } from "../../../../microservices/users_microservice";

const DeleteTenantAdministrator = () =>{
    const {user,logout} = useContext(AppContext);
    const {
        setReloadTenantAdministrators,
        selectedToDeleteTenantAdministrator,setSelectedToDeleteTenantAdministrator
    } = useContext(TenantAdministratorContext);
    const [customerUsersCount,setCustomerUsersCount] = useState(null);
    const [deletingTenantAdministratorStatus,setDeletingTenantAdministratorStatus] = useState('');
    const fetchAndSetCustomerUsersCount = async() =>{
        try{
            const url = `${usersMicroserviceUrl}/system-admins/tenants/${selectedToDeleteTenantAdministrator?.id}/customer-users/count`;
            const response = await fetch(url,{
                method:'GET',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok) setCustomerUsersCount((await response.json()).count);
            else if(response.status === 401) logout();
        }
        catch(error){
            console.error('An error occurred when retrieving the number of customer users created by this tenant administrator',error);
        }
    };
    const deleteTenantAdministrator = async() =>{
        try{
            setDeletingTenantAdministratorStatus('deleting');
            const url = `${usersMicroserviceUrl}/system-admins/tenants/${selectedToDeleteTenantAdministrator?.id}`;
            const response = await fetch(url,{
                method:'DELETE',
                headers:{
                    'Content-Type':'application/json',
                    'Authorization':`Bearer ${user?.access_token}`
                }
            });
            if(response.ok){
                setDeletingTenantAdministratorStatus('deleted');
                setReloadTenantAdministrators(true);
                return;
            }
            else if(response.status === 401){
                logout();
                return;
            }
        }
        catch(error){
            console.error('Unexpected error occurred when deleting tenant administrator',error);
        }
        setDeletingTenantAdministratorStatus('delete-error');
    };
    useEffect(() =>{
        if(selectedToDeleteTenantAdministrator){
            document.title = 'Blink IOT | Delete tenant administrator';
            fetchAndSetCustomerUsersCount();
        }
        else{
            document.title = 'Blink IOT | Tenant administrators';
            setDeletingTenantAdministratorStatus('');
        }
    },[selectedToDeleteTenantAdministrator]);
    useEffect(() =>{
        const handleEsc = (e) => {
            if(e.key === "Escape" && deletingTenantAdministratorStatus !== 'deleting') setSelectedToDeleteTenantAdministrator(null);
        };
        document.addEventListener("keydown",handleEsc);
        return () =>{
            document.removeEventListener("keydown",handleEsc);
        };
    },[selectedToDeleteTenantAdministrator,deletingTenantAdministratorStatus]);
    if(!selectedToDeleteTenantAdministrator) return null;
    return(
        <div className="system-administrator-delete-tenant-administrator-parent-container">
            {isNaN(Number(customerUsersCount)) || Number(customerUsersCount) !== 0?
                (
                    <div className="system-administrator-delete-tenant-administrator-customer-users-present-container">
                        <h1>Cannot delete this tenant administrator</h1>
                        <p>
                            This tenant administrator has {customerUsersCount} customer user{customerUsersCount === 1? '':'s'}.<br/>
                            Please delete all customer users they have created before attempting deletion.
                        </p>
                        <div className="system-administrator-delete-tenant-administrator-customer-users-present-okay-button-container">
                            <button onClick={() => setSelectedToDeleteTenantAdministrator(null)}>Okay</button>
                        </div>
                        <div className="system-administrator-delete-tenant-administrator-customer-users-present-escape-button-container"
                            onClick={() => setSelectedToDeleteTenantAdministrator(null)}>
                                <button>&#10006;</button>
                                <p>ESC</p>
                        </div>
                    </div>
                ):deletingTenantAdministratorStatus === ''?
                (
                    <div className="system-administrator-delete-tenant-administrator-container">
                        <h1>Delete tenant administrator "{selectedToDeleteTenantAdministrator?.firstName} {selectedToDeleteTenantAdministrator?.lastName}"?</h1>
                        <p>Once deleted, this tenant administrator cannot be recovered.</p>
                        <div className="system-administrator-delete-tenant-administrator-buttons-container">
                            <button className="cancel-delete-button"
                                onClick={() => setSelectedToDeleteTenantAdministrator(null)}>
                                Don't delete
                            </button>
                            <button className="delete-button" onClick={() => deleteTenantAdministrator()}>
                                Delete tenant administrator
                            </button>
                        </div>
                        <div className="system-administrator-delete-tenant-administrator-escape-button-container"
                            onClick={() => setSelectedToDeleteTenantAdministrator(null)}>
                            <button>&#10006;</button>
                            <p>ESC</p>
                        </div>
                    </div>
                ):deletingTenantAdministratorStatus === 'deleting'?
                (
                    <div className="system-administrator-deleting-tenant-administrator-container">
                        <div></div>
                        <p>Deleting tenant administrator. Please wait...</p>
                    </div>
                ):deletingTenantAdministratorStatus === 'deleted'?
                (
                    <div className="system-administrator-deleted-tenant-administrator-container">
                        <h1>Tenant administrator deleted</h1>
                        <p>Tenant administrator "{selectedToDeleteTenantAdministrator?.firstName} {selectedToDeleteTenantAdministrator?.lastName}" deleted successfully.</p>
                        <div className="system-administrator-deleted-tenant-administrator-okay-button-container">
                            <button onClick={() => setSelectedToDeleteTenantAdministrator(null)}>Okay</button>
                        </div>
                        <div className="system-administrator-deleted-tenant-administrator-escape-button-container"
                            onClick={() => setSelectedToDeleteTenantAdministrator(null)}>
                                <button>&#10006;</button>
                                <p>ESC</p>
                        </div>
                    </div>
                ):
                (
                    <div className="system-administrator-tenant-administrator-delete-error-container">
                        <h1>Error</h1>
                        <p>Unexpected error occurred when deleting tenant administrator "{selectedToDeleteTenantAdministrator?.firstName} {selectedToDeleteTenantAdministrator?.lastName}"</p>
                        <div className="system-administrator-tenant-administrator-delete-error-okay-button-container">
                            <button onClick={() => setSelectedToDeleteTenantAdministrator(null)}>Okay</button>
                        </div>
                        <div className="system-administrator-tenant-administrator-delete-error-escape-button-container"
                            onClick={() => setSelectedToDeleteTenantAdministrator(null)}>
                                <button>&#10006;</button>
                                <p>ESC</p>
                        </div>
                    </div>
                )
            }
        </div>
    );
};
export default DeleteTenantAdministrator;